export const enMessagesCams = {
  linkedAccounts: "Linked accounts",
  accountAccess: "Account access",
  exit: "Exit",
  accountRelationsSettings: "Account relations settings",
  sortBy: "Sort by:",
  language: "Language",
  languageSelection: "Language selection",
  view: "View ",
  byAddress: "By address",
  byHeading: "By heading",
  byDateAdded: "By date added",
  user: "User",
  tile: "Tile",
  list: "List",
  cancel: "Cancel",
  save: "Submit",
  myCameras: "My cameras",
  favorites: "Favorites",
  search: "Search",
  showAll: "Show all",
  mapOverview: "Overview",
  collapseEventFeed: "Collapse event feed",
  expandEventFeed: "Expand event feed",
  openEventFeedInNewWindow: "Open event feed in a new window",
  enableSoundNotifications: "Enable sound notifications",
  disableSoundNotifications: "Disable sound notifications",
  resizeEventFeed: "Resize event feed",
  exitFullscreen: "Exit fullscreen",
  cameraPreviewUnavailable: "Preview unavailable",
  backToCameraList: "Back to cameras",
  found: "Found",
  addresses: "Addresses",
  titles: "Titles",
  noResults: "No search results",
  createFolder: "Create Folder",
  editFolder: "Edit Folder",
  noCamerasFound: "No cameras found",
  saveSelectedCameras: "Save Selected Cameras",
  enterFolderName: "Enter folder name",
  folderCreate: "Folder Create Menu",
  saveChanges: "Save changes",
  createSubfolder: "Create subfolder",
  deleteFolder: "Delete folder",
  deleteFolderConfirmation: "Warning! Deleting the folder will also delete all subfolders and cameras.",
  folderDeletedSuccess: "Folder {folderName} was successfully deleted",
  changesSaved: "Changes saved",
  errorAddingCameras: "Error adding cameras",
  errorDeletingFolder: "Error deleting folder",
  createSubfolderFor: "Create subfolder for {folderName}",
  cameraDisabled: "Camera disabled",
  cameraNotFound: "Camera not found",
  embedCamera: "Embed on website",
  cameraSelectedForMonitor: "Camera selected for alarm monitor",
  cameraSelected: "Camera selected",
  viewOnline: "View online",
  viewArchive: "View archive",
  infoOfCamera: "Camera information",
  thermalImager: "Thermal imager",
  carNumberRecognition: "Car number recognition",
  faceRecognition: "Face recognition",
  helmetRecognition: "Helmet recognition",
  maskDetector: "Mask detector",
  perimeterDetector: "Perimeter detector",
  aircraftDetector: "Aircraft",
  crowdDetector: "Crowd detector",
  peopleCounter: "People counter",
  motionAlarm: "Motion alarm",
  parkingDetection: "Parking detection",
  player: "Player",
  embed: "Embed",
  thermalVisionReport: "Thermal Vision Report",
  carNumberReport: "Car Number Report",
  faceRecognitionReport: "Face Recognition Report",
  helmetReport: "Helmet Report",
  maskReport: "Mask Report",
  perimeterReport: "Perimeter Intrusion Report",
  aircraftReport: "Aircraft Report",
  motionAlarmReport: "Motion Alarm Report",
  parkingDetectionReport: "Parking Detection Alarm Report",
  crowdReport: "Crowd Report",
  peopleCountReport: "People Count Report",
  onMap: "On Map",
  width: "Width",
  height: "Height",
  fullscreen: "Fullscreen",
  autoplay: "Autoplay",
  https: "HTTPS",
  lowLatency: "Low Latency Mode",
  standardPlayback: "Standard playback. Video is delivered with a slight delay.",
  lowLatencyPlayback: "Video is streamed without delay. Not supported in some browsers.",
  sound: "Sound",
  hoursWithoutReload: "Hours of streaming without reload:",
  copyCode: "Copy Code",
  streamError: "Error: Failed to start the stream",
  copiedToClipboard: "Copied to clipboard",
  events: "Events",
  info: "Info",
  cameraNumber: "Camera №",
  cameraAddress: "Camera Address",
  timezoneOffset: "Timezone Offset",
  invalidDownloadRange: "Unable to download. The selected time range is incorrect, try changing the download boundaries.",
  downloadFailed: "Unable to download. Please try again later.",
  addCamera: "Add Camera",
  alarmCell: "Alarm Cell",
  streamUnavailable: "Stream unavailable. You need to change the camera.",
  alarm: "Alarm",
  deleteCamera: "Delete camera from cell",
  changeCamera: "Change camera in cell",
  moveToAnotherCell: "Move to another cell",
  selectCameraForCell: "Select a camera for the cell",
  newMosaic: "New Mosaic",
  enterTitle: "Enter title",
  addMosaic: "Add Mosaic",
  hideArchiveTools: "Hide archive tools",
  showArchiveTools: "Show archive tools",
  archive: "Archive",
  cancelChanges: "Cancel all changes and hide settings",
  showSettings: "Show current mosaic settings",
  setLowLatency: "Set low latency mode for all cameras",
  selectAlarmCameras: "Select alarm cameras for this mosaic",
  oneCamera: "1 camera",
  fourCamerasGrid: "4 cameras grid",
  grid5Title: "Grid 5",
  grid6Title: "Grid 6",
  grid8Title: "Grid 8",
  grid9Title: "Grid 9",
  grid10Title: "Grid 10",
  grid16Title: "Grid 16",
  deleteMosaic: "Delete current mosaic",
  delete: "Delete",
  alarmCameras: "Alarm Cameras",
  selectAllCameras: "Select all cameras",
  clearCameraSelection: "Clear",
  loadAlarmCamerasError: "Could not load the alarm camera list. Please try again.",
  setMosaicEventSource: "Set an event source from a mosaic",
  changeMosaicEventSource: "Change event source",
  selectEventCamerasOnMap: "Select on map",
  drawEventCameraArea: "Mark at least three corners of the area on the map, then click Save. Cameras inside will replace the mosaic's alarm cameras.",
  camerasInSelectedArea: "Cameras in area: {count}",
  undoAreaPoint: "Undo last point",
  chooseEventSourceMosaic: "Select a mosaic",
  noEventSourceMosaics: "No mosaics are available. Create a mosaic in Multiscreen.",
  loadMosaicEventSourceError: "Could not load mosaics and cameras. Please try again.",
  saveMosaicEventSourceError: "Could not save the mosaic cameras. Please try again.",
  mosaicEventSource: "Event source: {title}",
  mosaicEventSourceUnavailable: "The event source is unavailable. Select another mosaic.",
  mosaicEventSourceConnectionError: "Could not connect to events. Reconnecting.",
  retry: "Retry",
  audioEvents: "Audio events",
  videoEvents: "Video events",
  public: "Public Cameras",
  confirmDeleteMosaic: "Do you want to delete this mosaic?",
  deleteMosaicError: "Error while deleting the mosaic",
  deleteMosaicSuccess: "Mosaic deleted",
  saveChangesError: "Error occurred while saving. Please refresh the page and try again.",
  saveMosaicError: "Error occurred while saving the mosaic. Please create a new mosaic.",
  saveChangesSuccess: "Mosaic saved",
  newMosaicAdded: "New mosaic added",
  defaultMosaicRedirect: "Mosaic saved successfully",
  chooseCamerasForAlarm: "Choose cameras for alarm events on the mosaic",
  setAlarmCameras: "Press 'Save' to activate selected alarm cameras",
  setFullscreen: "Set fullscreen",
  archiveSettings: "Archive Settings",
  hideEventsCount: "Hidden events: ",
  hiddenThermalVisionEvents: "Hidden events for thermal vision: ",
  hiddenCarNumberEvents: "Hidden events for car numbers: ",
  hiddenFaceRecognitionEvents: "Hidden events for face recognition: ",
  hiddenHelmetEvents: "Hidden events for helmets: ",
  hiddenMotionAlarmEvents: "Hidden events for motion alarms: ",
  hiddenParkingDetectionEvents: "Hidden events for parking detection: ",
  hiddenMaskEvents: "Hidden events for masks: ",
  hiddenCrowdEvents: "Hidden events for crowding: ",
  hiddenPerimeterEvents: "Hidden events for perimeter security: ",
  hiddenPeopleCounterEvents: "Hidden events for people counter: ",
  editTitleTooltip: "Edit",
  titleSaveSuccess: "Camera title successfully changed",
  titleSaveError: "Error: ",
  titleWarning: "Title length cannot exceed 64 characters and cannot be empty",
  noEvents: "No events during this time interval.",
  deleteConfirmation: "Delete the link with the account?",
  accessHeader: "Account Access",
  nothingHere: "There's nothing here",
  createTokenMessage: "Create a new token for integrating third-party systems with our service via API",
  createToken: "Create Token",
  username: "Username",
  link: "Link",
  token: "Token",
  copy: "Copy",
  deleteToken: "Delete Token",
  copySuccess: "Copied to clipboard",
  addLinkPrompt: "To link cameras from another account, click add",
  add: "Add",
  enterUsername: "Enter username",
  password: "Enter password",
  accountLinkedSuccess: "Account linked successfully",
  inputUsernamePassword: "Enter username and password:",
  employees: "Users",
  accessDevices: "Access Devices",
  accessGroups: "Access Groups",
  cars: "Cars",
  searchPlaceholder: "Search",
  filterByGroupsPlaceholder: "Filter by Access Groups",
  addToGroup: "Add to Group",
  removeFromGroup: "Remove from Group",
  deleteEmployees: "Delete Users",
  addEmployee: "Add User",
  addEmployeeFromFile: "Add User from File",
  downloadReport: "Download Report",
  downloadReportCSV: "Download CSV",
  downloadReportXLSX: "Download XLSX",
  deleteEmployeeConfirm: "Do you want to delete this user?",
  deleteEmployeesConfirm: "Do you want to delete the selected users?",
  employeesDeleted: "Users deleted",
  employeeDeleted: "User deleted",
  errorDeletingEmployee: "Error deleting user",
  viewAll: "View All",
  deleteSelectedEmployeesConfirm: "Do you want to delete the selected users? Selected",
  removeEmployeesFromGroup: "Remove users from the group",
  addEmployeesToGroup: "Add users to the group",
  csvFileName: "User report.csv",
  totalEmployees: "Total users:",
  tableHeaders: {
    id: "ID",
    name: "Name",
    cars: "Cars",
    deviceAccessGroups: "Device Access Groups",
    isActive: "Active",
    identifier: "Identifier",
    emergencyVehicleAccess: "Emergency Vehicle Access",
    cameraCount: "Camera Count",
    cameras: "Cameras",
    title: "Title",
    about: "Additional Description",
    employee_count: "Number of Users",
    employee_ids: "Group Users",
    expired_date: "Expired date",
  },
  entry: "entry",
  employeeName: "User Name",
  enterEmployeeName: "Enter the user's full name",
  selectAccessGroups: "Select access groups, and the user will get access to devices",
  carNumbers: "Car Numbers",
  accountNumber: "Account (contract number)",
  isActive: "Active?",
  saveAndAddNew: "Save and add another",
  successEmployeeCreated: "User successfully created",
  getTemplate: "Get Template",
  successFileUploaded: "File successfully uploaded",
  errorFileUpload: "Error: ",
  errorLoadEntity: "Error: Unable to display information.",
  deviceAccessGroups: "Device Access Groups",
  addPhoto: "Add Photo",
  deletePhoto: "Delete Photo",
  noPhotos: "No Photos",
  attachedUsernames: "Account for Barrier Access (Contract Number)",
  employeeCarsCount: "Number of cars for user: ",
  accessSettings: "Access Settings",
  accessGroupList: "List of Access Groups:",
  viewGroup: "View Group: ",
  confirmDeletePhoto: "Do you want to delete this photo?",
  errorDeletePhoto: "Error while deleting photo",
  successSave: "Saved successfully",
  confirmDeleteEmployee: "Do you want to delete this user?",
  errorDeleteEmployee: "Error while deleting user",
  addDevice: "Add Device",
  chooseDevice: "Select Device",
  enterEmployee: "Enter User",
  more: "More",
  deviceFilter: "Filter by Devices",
  employeeFilter: "Filter by Users",
  device: "Device",
  employee: "User",
  accessLevel: "Access Level",
  notFound: "No permissions found.",
  foundCount: "Found: ",
  addPermissionError: "Error adding permissions",
  setPermissionError: "Error setting permissions",
  deletePermissionConfirm: "Do you want to delete these permissions?",
  devicePermissionDeleted: "Device permissions have been deleted",
  deletePermissionError: "Error deleting permissions",
  fullAccess: "Full Access",
  entrance: "Entrance",
  selectAccessGroupForDelete: "Select the access group to remove users from ",
  selectAccessGroupForAdd: "Select the access group to add users to ",
  enterAccessGroup: "Enter the access group",
  deleteFromGroup: "Remove from this group",
  errorDeleteEmployeesFromGroup: "Error while removing users from the group. ",
  errorAddEmployeesToGroup: "Error while adding users to the group. ",
  noData: "No data",
  totalCount: "Total",
  selectDevicePlaceholder: "Select device",
  selectGroupPlaceholder: "Enter the name of the access group",
  addGroup: "Add user group",
  groupFilter: "Filter by access groups",
  deviceHeader: "Device",
  groupHeader: "Access Group",
  noPermissions: "No permissions found",
  errorAddingPermissions: "Error adding permissions",
  errorUpdatingPermissions: "Error updating permissions",
  confirmDeletePermission: "Do you want to delete these permissions?",
  permissionDeleted: "Permission deleted",
  errorDeletingPermissions: "Error deleting permissions",
  allRowsSelected: "All rows selected",
  selectedRows: "Selected rows",
  selectAll: "Select all",
  deviceName: "Device Name",
  deviceState: "Device State",
  active: "Active",
  inactive: "Inactive",
  emergencyVehicleAccess: "Emergency Vehicle Access",
  available: "Available",
  notAvailable: "Not Available",
  cameraCountForDevice: "Number of cameras attached to the device",
  availableCamerasForUser: "Number of available cameras for the current user",
  noAvailableCamerasForUser: "No cameras available for the current user.",
  noCamerasAttachedToDevice: "No cameras are attached to the device.",
  editPermissionsForEmployees: "Edit Permissions for Users",
  editPermissionsForDeviceAccessGroups: "Edit Permissions for Device Access Groups",
  editAccessSettings: "Access Settings",
  deleteGroups: "Delete Groups",
  createAccessGroup: "Create Access Group",
  confirmDeleteGroup: "Do you want to delete this access group?",
  groupDeleted: "Access group deleted",
  errorDeletingGroup: "Error deleting access group",
  confirmDeleteGroups: "Do you want to delete the selected access groups? Selected: {count}",
  groupsDeleted: "Access groups deleted",
  errorDeletingGroups: "Error deleting access groups",
  groupTitle: "Group Title",
  groupAbout: "Additional Description",
  employeesCount: "Number of users in the group: ",
  viewAllEmployees: "View all users",
  addEmployeeToGroup: "Add user to the group",
  saveSuccess: "Saved successfully",
  deleteGroupConfirm: "Do you want to delete this access group?",
  employeeAddedToGroup: "User added to the group",
  errorAddingEmployees: "Error adding users to the group.",
  groupName: "Group Name",
  additionalDescription: "Additional Description",
  filterByEmployee: "Filter by user",
  deleteCars: "Delete cars",
  addCar: "Add car",
  createCarDialogTitle: "Create a car",
  confirmDeleteCar: "Do you want to delete this car?",
  carDeleted: "Car deleted",
  errorDeleteCar: "Error deleting the car",
  confirmDeleteSelectedCars: "Do you want to delete the selected cars? Selected: {count}",
  carsDeleted: "Cars deleted",
  errorDeleteCars: "Error deleting the cars",
  carNumber: "Car number",
  carOwner: "Car owner",
  existingEmployeeCars: "Existing user cars",
  shownCars: "Shown cars of the user",
  totalCars: "Total cars",
  accountLinkedTo: "Account linked to",
  deleteAccountLinkConfirmation: "Delete link with the account?",
  accessGranted: "Access granted",
  name: "Name",
  number: "Number",
  access: "Access",
  date: "Date",
  yes: "Yes",
  no: "No",
  unknown: "Unknown",
  startDate: "Start Date",
  endDate: "End Date",
  reset: "Reset",
  itemsPerPage: "Items per page",
  screenshot: "Screenshot",
  video: "Video",
  downloadVideo: "Download Video",
  text: "Text",
  archiveError: "Error: unable to access archive",
  crowdDetection: "Crowd Detected",
  screenshotEvent: "Screenshot Event",
  eventVideo: "Event Video",
  downloadEventVideo: "Download Event Video",
  noHelmet: "No Helmet",
  report: "Report",
  eventType: "Event type",
  loadAircraftReportCamerasError: "Failed to load report cameras. Please try again.",
  noMask: "No Mask",
  duration: "Duration (in sec.)",
  reportType: "Report Type",
  inCount: "People Entered",
  outCount: "People Exited",
  defaultReport: "General Report",
  hourly: "Hourly",
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  perimeterCrossing: "Perimeter Crossing",
  aircraftEvent: "Aircraft",
  aircraftEventConfidence: "Confidence: {value}%",
  minTemperature: "Min Temperature",
  maxTemperature: "Max Temperature",
  temperature: "Temperature",
  exceededTemperature: "Exceeded Temperature?",
  maxRowsWarning:
    "Displaying the maximum number of 1000 rows, additional records may be hidden. Refine filters to view them.",
  thermalCameras: "Thermal Cameras",
  motions: "Motions",
  helmets: "Helmets",
  masks: "Masks",
  crowdGathering: "Crowd Gathering",
  zoneCrossing: "Zone Crossing",
  tooManyRows: "The maximum number of rows displayed is 1000, other records may have been hidden. Refine the filters to see them.",
  eventText: "Event",
  eventDate: "Date",
  crowdReportFilename: "Crowd Report",
  defaultCrowdEvent: "Crowd Gathering",
  helmetReportFilename: "Helmet Report",
  helmetMissing: "Helmet Missing",
  maskReportFilename: "Mask Report",
  perimeterSecurityReportFilename: "Perimeter Security Report",
  unknownEvent: "Unknown",
  loadingError: "An error occurred while loading data. Please refine the filters.",
  motionReportFilename: "Motion Detection Report",
  thermalReportFilename: "Thermal Report",
  title: "Name",
  tariff: "Tariff",
  address: "Address",
  firmwareUpdateMessage: "Firmware is updating… do not close or refresh the page.",
  cameraModel: "Camera model",
  macAddress: "MAC address",
  firmwareVersion: "Firmware version",
  firmwareUpdateAvailable: "Update available",
  enableVideoStream: "Enable video stream",
  enableAudio: "Audio",
  ntpServer: "NTP server",
  videoResolution: "Resolution",
  videoBitrate: "Bitrate",
  nightModeEnable: "Night mode",
  timeZone: "Time zone",
  rebootCamera: "Reboot camera",
  confirmReboot: "Do you want to reboot the camera?",
  cameraRebootIn15Sec: "The camera will reboot in 15 seconds",
  configurationError: "Error during configuration",
  confirmUpgradeFirmware: "Firmware version {version} will be installed. Do not disconnect the camera from power or the internet. This may cause damage.",
  upgradeSuccess: "Firmware will be updated within 45 seconds",
  upgradeError: "An error occurred, please try again",
  screenshotAlt: "Event screenshot",
  screenshotProcessing: "Screenshot is being processed.",
  Movement: "Movement",
  continues: "continues",
  sec: "sec.",
  employeeId: "User",
  deviceId: "Device",
  specialTransport: "Special Transport",
  eventView: 'Event View',
  downloadError: 'Unable to download. Please try later.',
  screenshotView: 'Screenshot View',
  participants: '&copy; Contributors to {link}',
  insufficientRights: "Insufficient rights.",
  liveStreamTokenError: "Failed to obtain a token for live stream access.",
  archiveTokenError: "Failed to obtain a token for archive access.",
  multiscreen: "Multiscreen",
  map: "Map",
  scud: "ACS",
  setupCameras: "Setting up cameras",
  reloadToUpdate: "Do you want to reload the page to update?",
  reloadNow: "Reload now",
  postpone: "Postpone",
  newVersion: "A new version of the app is available",
  errorWhileLoading: "Oops, something went wrong while loading the page. Let's try reloading the page.",
  reload: "Reload",
  errorOccurred: "An error occurred",
  on: "On",
  off: "Off",
  auto: "Automatic mode",
  maxRowLimit: "Exceeded maximum number of rows for export ",
  addUsersToGroup: "Add users to group",
  step1GetTemplate: "Step 1: Get template file",
  downloadTemplateCSV: "Download CSV template",
  downloadTemplateXLSX: "Download XLSX template",
  step2ChooseFile: "Step 2: Select and upload completed file",
  selectFile: "Select file",
  selectedFile: "File selected",
  uploadFile: "Upload file",
  supportedFormatsHint: "Supported files: .xlsx. Up to 1000 users.",
  usernameHelp: "username or user identifier",
  carNumbersHelp: "car license plates",
  attachedAccountsHelp: "contract number or phone (to show the gate open button in the app)",
  accessGroupsHelp: "existing access groups (gates)",
  startTime: "Start time",
  endTime: "End time",
  notificationSchedule: "Notification schedule",
  fromSchedule: "C",
  toSchedule: "До",
  addSchedule: "Add schedule",
  confirmDeleteSchedule: "Are you sure you want to delete the schedule?",
  createSchedule: "Create schedule",
  editSchedule: "Edit schedule",
  selectServicePlaceholder: "Select a user",
  reasonPlaceholder: "Reason",
  addBan: "Add ban",
  noBans: "No bans found",
  bansAdded: "Ban added successfully",
  confirmDeleteBan: "Are you sure you want to delete this ban?",
  banDeleted: "Ban deleted successfully",
  errorDeletingBan: "Error deleting ban",
  barrierOpenError: "There was an error opening the barrier. Please try again later.",
  deleteCameraConfirmation: "Are you sure you want to delete the camera from the folder?",
  noChangesToSave: "No changes to save",
  detectionZone: "Detection zone",
  viewVideoFromCamera: "View video from camera №{number} - {title}",
  appError: "Oops... something went wrong.",
  mobileVersionInDevelopment: "Mobile version of the site is under development.",
  useMobileAppMessage: "You can use the \"{appName}\" app to view your cameras.",
  additionalAccount: "Additional account",
  accessControl: "Access Control",
  videoAnalytics: "Video Analytics",
  legacyBrowserWarning: "You are using an outdated browser",
  modernBrowserRecommendation: "Use the latest versions of modern browsers, for example:",
  fallDetectionReport: "Fall Detection Report",
  schedule: "Schedule",
  cameraLabel: "Camera {number}",
  enteredCount: "{count} Entered",
  exitedCount: "{count} Exited",
  viewLabel: "View:",
  enterDate: "Enter date",
  invalidDate: "Invalid date",
  peopleCount: "Number of people",
  resetPasswordTitle: "Resetting the password will reset the token, are you sure?",
  passwordAndTokenUpdated: "Password and token updated",
  errorResetPassword: "Error resetting password",
  confirmDeleteUser: "Are you sure you want to delete the user?",
  userDeleted: "User deleted",
  copied: "Copied!",
  placeholderEnterTitle: "Enter title",
  addedCamerasCount: "Added cameras: {count}",
  selectCameras: "Select cameras",
  resetPassword: "Reset password",
  deleteAccount: "Delete account",
  service: "Service",
  login: "Login",
  barrierPromoTitle: "To connect additional services, please contact the call center",
  freeCallHint: "Free call MegaFon, Beeline, MTS, Yota, T-Mobile",
  gotIt: "Got it",
  endDatePlaceholder: "Access expiration date",
  connectService: "Connect service",
  noAnalyticsCameras: "You don't have any cameras with analytics connected",
  peopleCounterDesc: "Find out how many people came to you",
  perimeterSecurityDesc: "We will notify you about the appearance of people in your specified area",
  fallDetectionDesc: "We will notify you about a person falling in your specified area",
  queueDetectionTitle: "Queue detection",
  queueDetectionDesc: "Monitor queue refills and notify your employees",
  requestStreamError: "An error occurred. It is impossible to request a video stream on this camera.",
  peopleCounterSetupTitle: "People counter setup",
  entryPointHint: "The green dot is the entry point. The system uses it to determine the direction of movement.",
  controlLineHint: "The red line is the control line along which the counting itself takes place.",
  important: "Important:",
  entryPointPlacementHint: "The green dot must be on one side of the control line, but not directly on the line.",
  entryPointDirectionHint: "The entry point determines from which side the system will count that a person is entering.",
  entryMechanismHint: "If a person moves from the green dot across the line - entry is counted. If in the opposite direction - exit.",
  recognitionThreshold: "Recognition threshold",
  confidenceHint: "If the system's confidence in correct recognition is below this value, the event will be discarded",
  confidenceCarHint: "If the system's confidence in correct recognition of the plate is below this value, and this plate is not in the company, it will be discarded",
  editRecognitionZone: "Edit recognition zone",
  saveScheduleError: "Error saving schedule",
  setup: "Setup",
  createAccount: "Create account",
  create: "Create",
  labelTitle: "Name",
  labelService: "Service",
  labelLogin: "Login",
  labelPassword: "Password",
  labelToken: "Token",
  passwordResetWarning: "Resetting the password will reset the token, are you sure?",
  setupAnalytics: "Setup analytics",
  fallDetection: "Fall detection",
  entered: "Entered",
  exited: "Exited",
  transportDetection: "Transport detection",
  transportDetectionEvent: "Transport detection",
  transportDetectionReportFilename: "Transport detection report",
  containerMonitoring: "Container Monitoring",
  containerMonitoringEvent: "Container Monitoring event",
  containerMonitoringReportFilename: "Container Monitoring report",
};
